// TaskDialog.js - Dialog-Komponente für das Hinzufügen/Bearbeiten von Aufgaben
import React from 'react';
import Dialog from '../common/Dialog';
import Button from '../common/Button';
import FormInput from '../common/FormInput';

/**
 * Dialog-Komponente für das Hinzufügen/Bearbeiten von Aufgaben
 * 
 * @param {Object} props - Komponenteneigenschaften
 * @param {boolean} props.isOpen - Bestimmt, ob der Dialog geöffnet ist
 * @param {boolean} props.isEditMode - Bestimmt, ob es sich um einen Bearbeitungs- oder Erstellungsdialog handelt
 * @param {Object} props.taskData - Die aktuellen Aufgabendaten
 * @param {Function} props.onInputChange - Callback für Änderungen an den Eingabefeldern
 * @param {Function} props.onSave - Callback für das Speichern der Aufgabe
 * @param {Function} props.onCancel - Callback für das Abbrechen des Dialogs
 * @param {Function} props.onDelete - Callback für das Löschen der Aufgabe (nur im Bearbeitungsmodus)
 */
const TaskDialog = ({ isOpen, isEditMode, taskData, onInputChange, onSave, onCancel, onDelete }) => {
  const dialogTitle = isEditMode ? 'Aufgabe bearbeiten' : 'Neue Aufgabe';
  const saveButtonText = isEditMode ? 'Aktualisieren' : 'Hinzufügen';

  // Dialog-Aktionen (Buttons)
  const dialogActions = (
    <>
      {isEditMode && (
        <Button
          variant="danger"
          onClick={onDelete}
        >
          Löschen
        </Button>
      )}
      <Button
        variant="secondary"
        onClick={onCancel}
      >
        Abbrechen
      </Button>
      <Button
        variant="primary"
        onClick={onSave}
      >
        {saveButtonText}
      </Button>
    </>
  );

  return (
    <Dialog
      isOpen={isOpen}
      title={dialogTitle}
      onClose={onCancel}
      actions={dialogActions}
    >
      <FormInput
        label="Name"
        name="name"
        value={taskData.name}
        onChange={onInputChange}
        required
      />
      
      <FormInput
        label="Stundensatz"
        name="hourlyRate"
        value={taskData.hourlyRate}
        onChange={onInputChange}
        type="number"
        placeholder="0.00"
      />
      
      <FormInput
        label="Tagessatz"
        name="dailyRate"
        value={taskData.dailyRate}
        onChange={onInputChange}
        type="number"
        placeholder="0.00"
      />
    </Dialog>
  );
};

export default TaskDialog;
